<template>
    <div class="error" v-if="error">
      <pre>{{error}}</pre>      
      <font-awesome-icon class="close-icon" icon="window-close" size="lg" @click="reset()" />
    </div>
</template>

<script>

import { SET_NO_ERROR } from "@/store/actions.type";

import { mapGetters } from "vuex";
export default {
    name: "Error",
     computed: {
      ...mapGetters(["error"])
    },
    methods:{
        reset(){
            this.$store.commit(SET_NO_ERROR);
        }
    }
}
</script>

<style scoped>

.error {
	border-radius: 5px;
	padding: 10px;
	margin: 10px;
	color: white;
	background: red;
	font-size: 1em;
	position: relative;
    width: auto;
}

.close-icon {
	position: absolute;
	top: 5px;
	right: 5px;
	font-size: 1.3em;
	background: gray;
	opacity: 0.9;
	border-radius: 5px;
    width: 55px;
    height: 55px;
}
.close-icon:hover{
    opacity: 0.8;
}
</style>


